import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=05e0f51d&"
import script from "./Layout.ts?vue&type=script&lang=js&"
export * from "./Layout.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports